import { AnyAction } from 'redux'
import { cloneDeep } from 'lodash';
import { FETCH_AGENDAS_DO_PROFISSIONAL, FETCH_FILTER_DROPDOWN_DATA, FETCH_PROFISSIONAIS_AGENDA, FILTER_AGENDAS_BY_NOME, FILTER_AGENDAS_BY_ROLE } from '../actions/agenda';
 
interface IAgendaReducer{ 
    agendasProfissionais: any[];
    agendasProfissional: any[];
    rolesComboFilter: any[];
}
 
const initialState: IAgendaReducer = {
    agendasProfissionais: [[{nome: 'Jane Cooper', isActive: true}, {nome: 'Jack Kirby', isActive: false}]],
    agendasProfissional: [],
    rolesComboFilter: []
}
 
export const AgendaReducer = (state = initialState, action: AnyAction) =>{
   switch(action.type){
        case FETCH_PROFISSIONAIS_AGENDA:{
            return{
                ...cloneDeep(state),
                agendasProfissionais: action.agendas
            }
        }
        case FETCH_AGENDAS_DO_PROFISSIONAL:{
            return {
                ...cloneDeep(state),
                agendasProfissional: action.agendas
            }
        }
        case FETCH_FILTER_DROPDOWN_DATA:{
            return {
                ...cloneDeep(state),
                rolesComboFilter: action.rolesCombo
            }
        }
        case FILTER_AGENDAS_BY_NOME:
        case FILTER_AGENDAS_BY_ROLE:{
            return {
                ...cloneDeep(state),
                agendasProfissionais: action.agendasFiltradas
            }
        }
       default:{
           return state
       }
   }
}

 